import React from 'react';
import { LeftNavigationAndTopNavigationLayout } from './LeftNavigationAndTopNavigationLayout';

type DashboardLayoutProps = {
    children: any
}

export const DashboardLayout = (props: DashboardLayoutProps) => (
    <>
        <LeftNavigationAndTopNavigationLayout />

        <main id="content" className="pt-5">
           {props.children}
        </main>
    </>
)